import { Action } from "redux";

import { TypedObject } from "@multiweb/types/react";
import { CLEAR, CLICK, INIT, SET_LOADING, UPDATE_OPTIONS } from "./constants";

/**
 * Struktura stavu modulu LinkButtonState.
 */
export interface ILinkButtonState {
    readonly url: string;
    readonly params: ReadonlyArray<string>;
    readonly functions: ReadonlyArray<string>;
    readonly isLoading: boolean;
    readonly instanceID?: string;
}

/**
* Data agregovaných hodnot indexovaných podle jejich klíčů.
*/
export type LinkButtonMapState = TypedObject<ILinkButtonState>;

export interface ILinkButtonMappedAction extends Action<string> {
    readonly meta: {
        readonly dataKey: string;
    };
}

export class ILinkButtonMappedAction {
    public static [Symbol.hasInstance](instance: any): boolean {
        return instance?.meta?.dataKey;
    }
}

export interface IInitLinkButtonAction extends ILinkButtonMappedAction {
    readonly payload: {
        readonly url: string;
        readonly params: string[];
        readonly functions: string[];
        readonly isLoading: boolean;
    };
}

export class IInitLinkButtonAction {
    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && instance.type === INIT;
    }
}

export interface ILinkButtonClearAction extends ILinkButtonMappedAction {}

export class ILinkButtonClearAction {
    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && instance.type === CLEAR;
    }
}

export interface ILinkButtonClickAction extends ILinkButtonMappedAction {}

export class ILinkButtonClickAction {
    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && instance.type === CLICK;
    }
}

export interface IUpdateLinkButtonOptionsAction extends ILinkButtonMappedAction {
    readonly payload: {
        readonly instanceID?: string;
    };
}

export class IUpdateLinkButtonOptionsAction {
    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && instance.type === UPDATE_OPTIONS;
    }
}

export interface ILinkButtonSetLoadingAction extends ILinkButtonMappedAction {
    readonly payload: {
        readonly isLoading: boolean;
    };
}

export class ILinkButtonSetLoadingAction {
    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && instance.type === SET_LOADING;
    }
}
